import Loading from '../../../../Dashboards/Common/Loading';
import { Table } from './Table';
import { Top10 } from './Top10';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

export const Charts = () => {
    const { isLoading } = useServicesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <Top10 />
                <Table />
            </div>
        </>
    );
};
